import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { getGradePillColors } from '../../../utils/intelligenceTheme';

interface GradePillProps {
  score: number;
}

export const GradePill: React.FC<GradePillProps> = React.memo(({ score }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const gradeInfo = getGradePillColors(score, isDark);

  return (
    <Chip
      label={gradeInfo.label}
      size="small"
      sx={{
        backgroundColor: gradeInfo.backgroundColor,
        color: gradeInfo.color,
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 24,
        border: `1px solid ${gradeInfo.borderColor}`,
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  );
});

export default GradePill;